import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Sessao} from '../../../../shared/model/sessao/sessao.model';
import {CardSessaoLinhaSuperiorComponent} from '../card-sessao-linha-superior/card-sessao-linha-superior.component';
import {MatCell} from '@angular/material/table';
import {CardSessaoLinhaCentralComponent} from '../card-sessao-linha-central/card-sessao-linha-central.component';
import {CardSessaoLinhaCanalComponent} from '../card-sessao-linha-canal/card-sessao-linha-canal.component';
import {CardSessaoLinhaInferiorComponent} from '../card-sessao-linha-inferior/card-sessao-linha-inferior.component';

@Component({
  selector: 'app-card-sessao-mobile',
  standalone: true,
  imports: [
    CardSessaoLinhaSuperiorComponent,
    MatCell,
    CardSessaoLinhaCentralComponent,
    CardSessaoLinhaCanalComponent,
    CardSessaoLinhaInferiorComponent
  ],
  templateUrl: './card-sessao-mobile.component.html',
  styleUrl: './card-sessao-mobile.component.css'
})
export class CardSessaoMobileComponent {

  @Input() sessao?: Sessao
  @Input() isExibicao = false;

  @Output() exibirDetalhes = new EventEmitter<Sessao>();
  @Output() modalChat = new EventEmitter<Sessao>();
  @Output() exibirEdicaoDetalhes = new EventEmitter<Sessao>();
  @Output() reiniciarSessao = new EventEmitter<Sessao>();


  abrirModalDetalhes(){
    this.exibirDetalhes.emit(this.sessao);
  }
  abrirModalChat(){
    this.modalChat.emit(this.sessao);
  }
  abrirModalEdicaoDetalhes(){
    this.exibirEdicaoDetalhes.emit(this.sessao);
  }
  abrirModalReiniciarSessao(){
    this.reiniciarSessao.emit(this.sessao);
  }

}
